import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, timeout: 180000, withCredentials: true });

export const getGuestId = () => {
  let id = localStorage.getItem("guest-id");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("guest-id", id);
  }
  return id;
};

http.interceptors.request.use((cfg) => {
  cfg.headers["X-Guest-Id"] = getGuestId();
  return cfg;
});

http.interceptors.response.use(null, async (err) => {
  const cfg = err.config;
  const url = cfg?.url || "";
  if (err.response?.status === 401 && !cfg._retried && !url.startsWith("/auth/")) {
    cfg._retried = true;
    try {
      await http.post("/auth/refresh");
      return http(cfg);
    } catch (e) {
      return Promise.reject(err);
    }
  }
  return Promise.reject(err);
});

export const DOMAIN_SHORT = [
  "Airway & disasters",
  "GA & sedation",
  "Pain medicine",
  "Periop & regional",
  "Crises & resus",
  "Safety & systems",
  "Paeds pathology & pharm",
  "Paeds emergencies",
  "Obstetric anaesthesia",
  "Obstetric emergencies",
  "Professional roles",
];

export const runJob = async (url, body) => {
  const { data } = await http.post(url, body);
  for (;;) {
    await new Promise((r) => setTimeout(r, 2500));
    const { data: j } = await http.get(`/jobs/${data.job_id}`);
    if (j.status === "done") return j.result;
    if (j.status === "error") throw new Error(j.error);
  }
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d === "string") return d;
  return e?.message || "Something went wrong";
};
